import { RepairContainer } from '../../containers/advancedFilters/RepairContainer';
import { IFilter } from '../../types/advancedFilters';

export const repair: IFilter = {
  component: RepairContainer,
};
